export const managementRoles = [
    {
        managementRole: "President",
        userswithRole: 2,
    }
];

export const accountingRoles = [
    {
        accountingRole: "Accountant",
        userswithRole: 2,
    },
    {
        accountingRole: "Accounts Payable",
        userswithRole: 0,
    },
    {
        accountingRole: "Accounts Receivable",
        userswithRole: 0,
    }
];

export const propertyManagementRoles = [
    {
        propertyManagementRole: "Regional Manager",
        userswithRole: 0,
    },
    {
        propertyManagementRole: "AProperty Manager",
        userswithRole: 10,
    },
    {
        propertyManagementRole: "Assistant Property Manager",
        userswithRole: 3,
    },
    {
        propertyManagementRole: "On-Site Manager",
        userswithRole: 0,
    }
];

export const leasingRoles = [
    {
        leasingRole: "Leasing Agent",
        userswithRole: 0,
    },
    {
        leasingRole: "Assistant Leasing Agent",
        userswithRole: 5,
    },
];

export const maintenanceRoles = [
    {
        maintenanceRole: "Maintenance Coordinator",
        userswithRole: 0,
    },
    {
        maintenanceRole: "Maintenance Tech",
        userswithRole: 0,
    },
];

export const miscSupportRoles = [
    {
        miscSupportRole: "View Only",
        userswithRole: 21,
    },
];